







import { Vue, Component, Prop } from 'vue-property-decorator';
import UserIcon from '../icon/UserIcon.vue';
import WhiteBlackButton from './WhiteBlackButton.vue';

@Component({ components: { UserIcon, WhiteBlackButton } })
export default class ProfielEditButton extends Vue {
  @Prop({ default: false })
  private isReEdit!: boolean;

  get title() {
    return this.isReEdit ? 'ユーザー設定' : 'プロフィール編集';
  }
  private css_class = ['d-block', 'py-1', 'px-sm-4', 'w-sm-11rem', 'w-9rem'];
}
